import { CancelTokenSource } from 'axios';
import axios from 'services/http';
import {
  AutomaticPaymentRunDto,
  BillPaymentResponse,
  ImportAutomaticPaymentRequest,
  ImportAutomaticPaymentResponse
} from 'ts-types/api.types';

const {REACT_APP_API_BASE_URL: baseUrl} = process.env;

export const searchBills = (billSearchRequest: any, source: CancelTokenSource): Promise<Array<any>> => {
  return axios
      .post(`${baseUrl}/api/search-bills`, billSearchRequest, {cancelToken: source.token})
      .then(response => response.data);
};

export const payBills = (billPaymentRequest: any, source: CancelTokenSource): Promise<BillPaymentResponse> => {
  return axios
      .post(`${baseUrl}/api/pay-bills`, billPaymentRequest, {cancelToken: source.token})
      .then(response => response.data);
};

export const automaticPayBills = (
    billPaymentRequest: any, source: CancelTokenSource)
    : Promise<AutomaticPaymentRunDto> => {

  return axios
      .post(`${baseUrl}/api/automatic-pay-bills`,
          billPaymentRequest,
          {
            cancelToken: source.token,
            timeout: 10 * 60 * 1000
          })
      .then(response => response.data);
};

export const getExecutingAutomaticPaymentRunStatus = (source: CancelTokenSource)
    : Promise<AutomaticPaymentRunDto> => {

  return axios
      .get(`${baseUrl}/api/automatic-payment-run/in-progress`, {cancelToken: source.token})
      .then(response => response.data);
};

export const getAutomaticPaymentRunStatus = (
    runId: number, source: CancelTokenSource)
    : Promise<AutomaticPaymentRunDto> => {

  return axios
      .get(`${baseUrl}/api/automatic-payment-run/${runId}`, {cancelToken: source.token})
      .then(response => response.data);
};

export const getAutomaticPaymentProgressResult = (
    pdfId: string, source: CancelTokenSource)
    : Promise<BillPaymentResponse> => {

  return axios
      .get(`${baseUrl}/api/automatic-pay-bills/${pdfId}/result`, {cancelToken: source.token})
      .then(response => response.data);
};

export const payCcPayedBillsPatient = (source: CancelTokenSource): Promise<BillPaymentResponse> => {
  return axios
      .post(`${baseUrl}/api/pay-cc-payed-bills-patient`, {}, {cancelToken: source.token})
      .then(response => response.data);
};

export const payCcPayedBillsGuarantor = (source: CancelTokenSource): Promise<BillPaymentResponse> => {
  return axios
      .post(`${baseUrl}/api/pay-cc-payed-bills-guarantor`, {}, {cancelToken: source.token})
      .then(response => response.data);
};

export const getManualPaymentProofListPdfUrl = (manualPaymentPdfId: string, manualPaymentPdfName: string) => {
  return `${baseUrl}/f06bd70712f343a685b23f95bc5437ce/${manualPaymentPdfId}/${manualPaymentPdfName}`;
};

export const getAutomaticPaymentProofListPdfUrl = (paymentPdfId: string, paymentPdfName: string) => {
  return `${baseUrl}/a06bd70712f343a685b23f95bc5437aa/${paymentPdfId}/${paymentPdfName}`;
};

export const importAutomaticPayments = (values: Partial<ImportAutomaticPaymentRequest>,
                                        source: CancelTokenSource): Promise<ImportAutomaticPaymentResponse> => {

  let bodyFormData = new FormData();
  Object.keys(values).forEach((key) => {
    let value = values[key as keyof ImportAutomaticPaymentRequest];
    if (value) {
      if (Array.isArray(value)) {
        value.forEach(val => {
          bodyFormData.append(key, val);
        })
      }
    }
  });

  return axios
      .post(`${baseUrl}/api/import-automatic-payments`, bodyFormData, {cancelToken: source.token})
      .then(response => response.data);
};
